import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CompanySettings } from '@pxtra-client-lib-legacy/gen';
import { DataGrid, DataGridElement } from '../../../../../lib/components/compound/dataGrid';
import { format, parseISO } from 'date-fns';
import { Typography } from '@mui/material';

interface Props {
  data?: CompanySettings;
}

export const HrisPauseView: FC<Props> = ({ data }) => {
  const { t } = useTranslation();

  return (
    <>
      <DataGrid>
        <DataGridElement
          value={data?.hris_integration_status === 'PAUSED' ? 'Pausiert' : 'Aktiv'}
          title={t('common:STATE')}
          xs={6}
        />
        <>
          {(data?.hris_integration_status === 'PAUSED' && (
            <DataGridElement
              value={
                data?.hris_pause_date
                  ? format(parseISO(data?.hris_pause_date), 'dd.MM.yyyy')
                  : undefined
              }
              title={t('company:END_OF_PAUSE')}
              xs={6}
            />
          )) ||
            []}
        </>
      </DataGrid>
      <Typography p={2}>{t('company:PAUSE_NOTE')} </Typography>
    </>
  );
};
